import { Report193Container } from "../../../containers/borrowSystem/Report/Report193Container";

export function Report193Page() {
    return (
        <Report193Container />
    )
}